<script setup lang="ts">
import BaseIcon from '@/components/ui/BaseIcon.vue';

withDefaults(defineProps<{ size?: 'small' | 'medium' }>(), { size: 'small' });
</script>

<template>
  <span class="on-demand-tag" :class="`on-demand-tag--${size}`">
    <BaseIcon name="hand" class="on-demand-tag__icon" />
    {{ $t('onDemand.tag') }}
  </span>
</template>

<style lang="scss">
.on-demand-tag {
  align-items: center;
  background-color: $color-neutral-low;
  border-radius: $radius-tag;
  color: $color-text-dark;
  display: inline-flex;
  flex-shrink: 0;
  gap: $spacing-1;
  height: 24px;
  padding: 0 $spacing-1;
  white-space: nowrap;

  &--small {
    font: $label-small;
    letter-spacing: $label-small-spacing;

    .on-demand-tag__icon {
      font-size: 14px;
    }
  }

  &--medium {
    font: $label-medium;
    letter-spacing: $label-medium-spacing;

    .on-demand-tag__icon {
      font-size: 16px;
    }
  }
}
</style>
